import {
  REPORT_SEARCH, REPORT_SEARCH_SUCCESS, REPORT_SEARCH_FAILURE, REPORT_SEARCH_CLEAR,
  REPORT_LIST_SEARCH, REPORT_LIST_SEARCH_SUCCESS, REPORT_LIST_SEARCH_FAILURE, REPORT_LIST_SEARCH_CLEAR,
  REPORT_DELETE, REPORT_DELETE_SUCCESS, REPORT_DELETE_FAILURE,
  REPORT_PDF, REPORT_PDF_SUCCESS, REPORT_PDF_FAILURE,
  REPORT_REMOVE_PDF, REPORT_REMOVE_PDF_SUCCESS, REPORT_REMOVE_PDF_FAILURE,
  REPORT_MEDICINE_SEARCH, REPORT_MEDICINE_SEARCH_SUCCESS, REPORT_MEDICINE_SEARCH_FAILURE
} from './mutation-types'
var utils = require('../../utils')
import constant from '../constant'

export default {
  utils: utils,
  state: {
    report: null,
    reportPatient: null,
    reportPlan: null,
    reportSendCancelable: false,  // 送信中止可能な状態
    reportSendReStartable: false, // 送信再開可能な状態
    reportExists: true,
    reportList: null,
    reportListNextPage: null,
    reportListTotalCount: 0,
    reportListNextPageLink: null,
    reportListCurrentPage: null,
    reportListExists: true,
    reportListParams: null,
    reportNotify: null,
    medicineData: null
  },
  getters: {
    report: state => {
      return state.report
    },
    reportPlan: state => {
      return state.reportPlan
    },
    reportPatient: state => {
      return state.reportPatient
    },
    reportSendCancelable: state => {
      return state.reportSendCancelable // 送信中止可能な状態
    },
    reportSendReStartable: state => {
      return state.reportSendReStartable // 送信再開可能な状態
    },
    reportExists: state => {
      return state.reportExists
    },
    reportList: state => {
      return state.reportList
    },
    reportListNextPage: state => {
      return state.reportListNextPage
    },
    reportListTotalCount: state => {
      return state.reportListTotalCount
    },
    reportListNextPageLink: state => {
      return state.reportListNextPageLink
    },
    reportListCurrentPage: state => {
      return state.reportListCurrentPage
    },
    reportListParams: state => {
      return state.reportListParams
    },
    reportNotify: state => {
      return state.reportNotify
    },
    nsUsage: state => {
      return state.medicineData
    }
  },
  actions: {
    /** 報告書詳細 */
    [REPORT_SEARCH] ({dispatch, state, commit}, params) {
      var data = {}
      var url = '/reports/' + params.reportId
      var loadparams = true
      var callback = params.callback
      state.report = null
      state.reportPlan = null
      state.reportPatient = null
      state.reportSendCancelable = false
      state.reportSendReStartable = false
      state.reportExists = true
      if (params) {
        data = params.data
        if ('loadparams' in params) {
          loadparams = params.loadparams
        }
      }
      dispatch('apiGet', {url: url, data: data, loadparams: loadparams})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(REPORT_SEARCH_FAILURE, res.data)
          } else {
            commit(REPORT_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [REPORT_SEARCH_CLEAR] ({state, commit}, sleep = 0) {
      setTimeout(() => {
        commit(REPORT_SEARCH_CLEAR)
      }, sleep)
    },

    /** 報告書検索 */
    [REPORT_LIST_SEARCH] ({dispatch, state, commit}, params) {
      var data = {}
      var url = '/reports'
      var loadparams = true
      var callback = () => {}
      state.reportListExists = true
      if (params) {
        data = params.data
        state.reportListParams = params.data
        if ('loadparams' in params) {
          loadparams = params.loadparams
        }
        if (params.url) {
          url = params.url
        }
        if (params.clear) {
          state.reportList = null
          state.reportListNextPage = null
          state.reportListTotalCount = 0
          state.reportListNextPageLink = null
          state.reportListCurrentPage = null
        }
        if (params.callback) {
          callback = params.callback
        }
      }
      dispatch('apiGet', {url: url, data: data, loadparams: loadparams})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(REPORT_LIST_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(REPORT_LIST_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [REPORT_LIST_SEARCH_CLEAR] ({state, commit}, sleep = 0) {
      setTimeout(() => {
        commit(REPORT_LIST_SEARCH_CLEAR)
      }, sleep)
    },

    /** 報告書削除 */
    [REPORT_DELETE] ({dispatch, state, commit}, params) {
      var data = {}
      var url = '/reports/' + params.reportId
      var loadparams = 'block'
      var callback = params.callback
      if (params) {
        data = params.data
        if ('loadparams' in params) {
          loadparams = params.loadparams
        }
      }
      dispatch('apiDelete', {url: url, data: data, loadparams: loadparams})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(REPORT_DELETE_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(REPORT_DELETE_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },

    [REPORT_PDF] ({dispatch, state, commit}, params) {
      var data = {}
      var loadparams = true
      if (params) {
        data = params.data
        if ('loadparams' in params) {
          loadparams = params.loadparams
        }
      }
      dispatch('apiGet', {url: '/reports/pdf', data: data, loadparams: loadparams})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(REPORT_PDF_FAILURE, res.data)
            } else {
              commit(REPORT_PDF_SUCCESS, {
                data: res.data,
                callback: params.callback
              })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },

    [REPORT_REMOVE_PDF] ({dispatch, state, commit}, params) {
      var data = {}
      var loadparams = false
      if (params) {
        data = params.data
        if ('loadparams' in params) {
          loadparams = params.loadparams
        }
      }
      setTimeout(() => {
        dispatch('apiDelete', {url: '/reports/remove_pdf', data: data, loadparams: loadparams})
          .then(res => {
            if (res.status === 200 || res.status === 304) {
              if (res.data.error) {
                commit(REPORT_REMOVE_PDF_FAILURE, res.data)
              } else {
                commit(REPORT_REMOVE_PDF_SUCCESS, {
                  data: res.data,
                  callback: params.callback
                })
              }
            }
          })
          .catch(error => {
            throw error
          })
      }, 5000)
    },
    [REPORT_MEDICINE_SEARCH] ({dispatch, state, commit}, params) {
      var url = '/reports/report_medicine_search'
      var data = {}
      var loadparams = null
      if (params) {
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: loadparams})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(REPORT_MEDICINE_SEARCH_FAILURE, res.data)
          } else {
            commit(REPORT_MEDICINE_SEARCH_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    /** 報告書詳細検索失敗 */
    [REPORT_SEARCH_FAILURE] (state, params) {
      console.log('REPORT_SEARCH_FAILURE')
      state.report = null
      state.reportPlan = null
      state.reportSendCancelable = false  // 送信中止可能な状態
      state.reportSendReStartable = false // 送信再開可能な状態
      state.reportPatient = null
      state.reportExists = false
      // 通知
      state.reportNotify = {
        danger: true,
        message_i18n: 'messages.search.danger'
      }
      setTimeout(() => {
        state.reportNotify = null
      }, constant.notifyShowTime.normal)
      params.callback()
    },
    /** 報告書詳細検索成功 */
    [REPORT_SEARCH_SUCCESS] (state, params) {
      console.log('REPORT_SEARCH_SUCCESS')
      var data = params.data
      state.report = data.report
      state.reportPlan = data.plan
      state.reportSendCancelable = data['send_cancelable'] // 送信中止可能な状態
      state.reportSendReStartable = data['send_restartable'] // 送信再開可能な状態
      state.reportPatient = data.patient
      state.reportExists = true
      params.callback()
    },
    /** 報告書詳細クリア */
    [REPORT_SEARCH_CLEAR] (state) {
      state.report = null
      state.reportPlan = null
      state.reportSendCancelable = false  // 送信中止可能な状態
      state.reportSendReStartable = false // 送信再開可能な状態
      state.reportPatient = null
    },

    /** 報告書詳索失敗 */
    [REPORT_LIST_SEARCH_FAILURE] (state, data) {
      console.log('REPORT_LIST_SEARCH_FAILURE')
      state.reportListExists = false
      // 通知
      state.reportNotify = {
        danger: true,
        message_i18n: 'messages.search.danger'
      }
      setTimeout(() => {
        state.reportNotify = null
      }, constant.notifyShowTime.normal)
      if (data.callback) {
        data.callback()
      }
    },
    /** 報告書検索成功 */
    [REPORT_LIST_SEARCH_SUCCESS] (state, params) {
      console.log('REPORT_LIST_SEARCH_SUCCESS')
      var data = params.data
      var reSearch = false

      state.reportListTotalCount = 0

      if (data.meta) {
        if (data.meta['re-search']) {
          reSearch = data.meta['re-search']
        }

        if (reSearch) {
          // 再検索
          state.reportList = data.data
          if (data.meta['next-page'] === null) {
            // 次へのリンクが無かったら
            state.reportListNextPage = null
          }
        } else {
          if (data.meta['current-page'] && data.meta['current-page'] > 1) {
            state.reportList = state.reportList.concat(data.data)
            state.reportListCurrentPage = data.meta['current-page']
          } else {
            state.reportList = data.data
            state.reportListCurrentPage = data.meta['current-page']
          }
          state.reportListNextPage = null
          if (data.meta['next-page']) {
            state.reportListNextPage = data.meta['next-page']
          }
        }
        if (data.meta['total-count']) {
          state.reportListTotalCount = data.meta['total-count']
        }
        if (data.links && data.links['next']) {
          state.reportListNextPageLink = data.links['next']
        } else {
          state.reportListNextPageLink = null
        }
      } else {
        state.reportList = data.data
      }

      if (state.reportListTotalCount > 0) {
        state.reportListExists = true  // データあり
      } else {
        state.reportListExists = false // データなし
      }
      if (params.callback) {
        params.callback()
      }
    },
    /** 報告書検索クリア */
    [REPORT_LIST_SEARCH_CLEAR] (state) {
      state.reportList = null
    },

    /** 報告書削除失敗 */
    [REPORT_DELETE_FAILURE] (state, data) {
      console.log('REPORT_DELETE_FAILURE')
      // 通知
      state.reportNotify = {
        danger: true,
        message_i18n: 'messages.delete.danger'
      }
      setTimeout(() => {
        state.reportNotify = null
      }, constant.notifyShowTime.normal)
    },
    /** 報告書削除成功 */
    [REPORT_DELETE_SUCCESS] (state, params) {
      console.log('REPORT_DELETE_SUCCESS')
      var callback = params.callback
      // 通知
      state.reportNotify = {
        success: true,
        message_i18n: 'messages.delete.success_report_delete'
      }
      setTimeout(() => {
        state.reportNotify = null
      }, constant.notifyShowTime.short)
      callback()
    },
    [REPORT_PDF_FAILURE] (state, data) {
      console.log('REPORT_PDF_FAILURE')
      // 通知
      state.reportNotify = {
        danger: true,
        message_i18n: 'messages.pdf.danger'
      }
      setTimeout(() => {
        state.reportNotify = null
      }, constant.notifyShowTime.normal)
    },
    [REPORT_PDF_SUCCESS] (state, data) {
      console.log('REPORT_PDF_SUCCESS')
      data.callback(data.data)
    },
    [REPORT_REMOVE_PDF_FAILURE] (state, data) {
      console.log('REPORT_REMOVE_PDF_FAILURE')
    },
    [REPORT_REMOVE_PDF_SUCCESS] (state, data) {
      console.log('REPORT_REMOVE_PDF_SUCCESS')
      if (data.callback) {
        data.callback(data.data)
      }
    },
    [REPORT_MEDICINE_SEARCH_FAILURE] (state, data) {
      console.log('REPORT_MEDICINE_SEARCH_FAILURE')
    },
    [REPORT_MEDICINE_SEARCH_SUCCESS] (state, data) {
      console.log('REPORT_MEDICINE_SEARCH_SUCCESS')
      state.medicineData = data.data
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/report.js